<template>
  <form @submit.prevent="submit">
    <label class="block mb-6">
      <p class="text-gray-700 text-xs font-bold tracking-wide mb-2">CURSO</p>
      <Treeselect :options="courses" v-model="course" />
    </label>
    <label class="block mb-6">
      <p class="text-gray-700 text-xs font-bold tracking-wide mb-2">GRUPO</p>
      <Treeselect :options="groups" v-model="group" />
    </label>
    <div class="flex items-center justify-end pt-4 border-t">
      <button
        :disabled="course === null || group === null"
        class="hover:bg-indigo-600 hover:text-white hover:border-transparent border border-gray-600 rounded focus:outline-none px-4 py-2"
      >
        Asignar
      </button>
    </div>
  </form>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: {
    Treeselect,
  },
  props: {
    students: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      course: null,
      group: null,
    };
  },
  computed: {
    ...mapState(["user"]),
    ...mapGetters(["currentTab"]),
    courses() {
      return this.currentTab.extras.courses.map((course) => {
        return {
          id: course.ID_Curso,
          label: course.ID_Curso,
        };
      });
    },
    groups() {
      return this.currentTab.extras.groups.map((group) => {
        return {
          id: group.descripcion,
          label: group.descripcion,
        };
      });
    },
  },
  methods: {
    ...mapActions(["requestEntries"]),
    ...mapMutations(["hideModal"]),
    submit() {
      const data = this.students.map((student) => {
        return {
          num: student.num,
          ID_Curso: this.course,
          grupo: this.group,
        };
      });
      axios
        .post("server/index.php", {
          action: "asignCourseAndGroup",
          user: this.user.num,
          colegio: this.user.colegio,
          data,
        })
        .then(() => {
          this.hideModal();
          this.requestEntries();
        });
    },
  },
};
</script>
